// extracted by mini-css-extract-plugin
module.exports = {"cp-subscription-status":"styles_cp-subscription-status__1OgTX"};